import HistoricRiskDataGrid from './HistoricRiskDataGrid';
export { HistoricRiskDataGrid };
export default HistoricRiskDataGrid;
